import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useCallback,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import { getInitFormData, getNoSlip } from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/GridV2/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
import SnResizeBar from "@shared/components/SnResizeBar";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_PRD_BAS_REG_015 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const { userInfo } = global(); // Login user 정보
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    grid3: React.createRef(),
  });
  const searchRef = useRef<any>(null);
  const isUpdatingRef = useRef(false);
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });

  const [rowCountGrid1, setRowCountGrid1] = useState(0);
  const [rowCountGrid2, setRowCountGrid2] = useState(0);
  const [focusedRowData, setFocusedRowData] = useState<any>();

  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
        });

        setFormData((prevData: any) => ({
          ...prevData,
          cd_module: Menuprops.cd_module,
        }));
      } catch (error) {}
    };
    fetchform();
  }, []);

  //   useEffect(() => {
  //     if (Array.isArray(dataSources.grid1)) {
  //       setRowCountGrid1(dataSources.grid1.length);
  //     }
  //   }, [dataSources.grid1]);

  //   useEffect(() => {
  //     if (Array.isArray(dataSources.grid2)) {
  //       setRowCountGrid2(dataSources.grid2.length);
  //     }
  //   }, [dataSources.grid2]);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
  }));

  const onSearch = async () => {
    const modifiedRows2 = gridRefs.current["grid2"].current.getChange();
    const modifiedRows3 = gridRefs.current["grid3"].current.getChange();
    if (
      modifiedRows2.modifiedRowcount > 0 ||
      modifiedRows3.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      const params = {
        id: "sn_prd_bas_reg_015_01",
        params: searchRef.current.getFormdata(),
      };

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();

      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
        grid2: data[1] || [],
        grid3: data[2] || [],
      });
    } catch (error: any) {}
  };

  const onAddRow = async () => {
    try {
      gridRefs.current["grid2"].current?.addRow();
    } catch {}
  };

  const onBeforeAddRow2 = (): boolean | Record<string, any> => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      const searchInfo = searchRef.current.getFormdata();
      if (focusedNodeH == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }
      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: searchInfo.cd_biz,
        fg_equip: focusedNodeH.data?.fg_equip,
        qt_exam_min: 1,
        yn_equip_app: "Y",
      };

      return updatedRow;
    } catch (error: any) {
      return false; // 추가 취소
    }
  };

  const onAddRow2 = async () => {
    try {
      gridRefs.current["grid3"].current?.addRow();
    } catch {}
  };

  const onBeforeAddRow3 = (): boolean | Record<string, any> => {
    try {
      gridRefs.current["grid2"].current?.stopEditing();
      const focusedNodeL = gridRefs.current["grid2"].current.focusedRowNode();
      if (focusedNodeL == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }
      const maxNoLine =
        gridRefs.current["grid3"].current.getMaxValue("no_line");
      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        tp_exam: "QLT",
        qt_lcl: 0,
        qt_ucl: 0,
        no_line: maxNoLine + 1,
        fg_equip: focusedNodeL.data?.fg_equip,
        cd_part: focusedNodeL.data?.cd_part,
      };

      return updatedRow;
    } catch (error: any) {
      return false; // 추가 취소
    }
  };

  const onDeleteRow = async () => {
    if (gridRefs.current["grid2"].current?.getDisplayedRowCount() < 1) return;

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");
    if (!confirm) return;

    gridRefs.current["grid3"].current.deleteAllRows();
    gridRefs.current["grid2"].current.deleteSelectedRows();

    const realDeletedRows =
      gridRefs.current["grid2"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      return;
    }

    return await onSave();
  };

  const onDeleteRow2 = async () => {
    if (gridRefs.current["grid3"].current?.getDisplayedRowCount() < 1) return;

    gridRefs.current["grid3"].current?.deleteSelectedRows();
  };

  const onSave = async () => {
    try {
      gridRefs.current["grid2"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();

      const requiredValuesCheck2 =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheck2) {
        return false;
      }
      const requiredValuesCheck3 =
        gridRefs.current["grid3"].current.requiredValuesCheck();
      if (!requiredValuesCheck3) {
        return false;
      }
      const examrulehChanges = gridRefs.current["grid2"].current.getChange();
      const examrulelChanges = gridRefs.current["grid3"].current.getChange();
      const lineInserts = examrulehChanges.insert ?? [];
      const lineInserts2 = examrulelChanges.insert ?? [];

      if (
        lineInserts.modifiedRowcount === 0 &&
        lineInserts2.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      const SaveData = {
        equip_examruleh: examrulehChanges,
        equip_examrulel: examrulelChanges,
      };

      const ok = await fnSave("SN_PRD_BAS_REG_015_SAVE_01", SaveData);
      if (!ok) return false;

      gridRefs.current["grid3"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid1"].current.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid3"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      gridRefs.current["grid1"].current.resetUpdate(true);
      return false;
    }
  };
  //#endregion

  //#region  Event Method

  const onCellValueChanged = async (event: any) => {
    if (!event) return;

    const colId = event.colId;
    const rowNode = event.rowNode;
    const targetFields = ["tm_st", "tm_setup", "tm_work"];

    if (!targetFields.includes(colId)) return;

    const rawValue: string = String(event.newValue ?? "").trim();

    if (rawValue.length > 0 && (rawValue.length < 6 || rawValue.length > 6)) {
      showDialog("alter", "시간은 6 자리가 필요합니다.");
      rowNode.setDataValue(colId, "");
      return;
    }

    if (rawValue.length === 6) {
      const hours = parseInt(rawValue.substring(0, 2), 10);
      const minutes = parseInt(rawValue.substring(2, 4), 10);
      const seconds = parseInt(rawValue.substring(4, 6), 10);

      if (hours >= 24 || minutes >= 60 || seconds >= 60) {
        showDialog("alter", "시간은 23:59:59 까지 입력할 수 있습니다.");
        rowNode.setDataValue(colId, "");
        return;
      }
    }
  };
  //#endregion

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {},
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          //   onCellValueChanged: onCellValueChanged,
          onBtnAddClick: onAddRow,
          onBtnDeleteClick: onDeleteRow,
          onBeforeAddRow: onBeforeAddRow2,
        },
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
        events: {
          //   onCellValueChanged: onCellValueChanged,
          onBtnAddClick: onAddRow2,
          onBtnDeleteClick: onDeleteRow2,
          onBeforeAddRow: onBeforeAddRow3,
        },
      },
    }),
    [columns, dataSources]
  );

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        />
      </div>
      <div className="w-full flex space-x-2 flex-grow overflow-x-hidden">
        <SnResizeBar direction={"width"} id="panel2" orgSize="19.5%">
          <div className="flex-1 h-full min-h-0 space-y-1.5">
            <SnGrid
              ref={gridRefs.current["grid1"]} // Grid Name
              columnConfig={grids.grid1.columns} // 컬럼 설정 전달
              rowData={grids.grid1.dataSource} // Datasource
              etcProps={{ rowSelection: "single", title: "설비정보" }}
              events={grids.grid1.events}
              filter={{
                refs: [gridRefs.current["grid2"]],
                columns: ["fg_equip"],
              }}
            />
          </div>
        </SnResizeBar>
        <SnResizeBar direction={"width"} id="panel3" orgSize="79.9%">
          <SnResizeBar direction={"height"} id="panel1" orgSize="49.9%">
            <SnGrid
              ref={gridRefs.current["grid2"]} // Grid Name
              columnConfig={grids.grid2.columns} // 컬럼 설정 전달
              rowData={grids.grid2.dataSource} // Datasource
              etcProps={{ rowSelection: "single", title: "점검부위" }}
              events={grids.grid2.events}
              filter={{
                refs: [gridRefs.current["grid3"]],
                columns: ["fg_equip", "cd_part"],
              }}
            />
            <SnGrid
              ref={gridRefs.current["grid3"]} // Grid Name
              columnConfig={grids.grid3.columns} // 컬럼 설정 전달
              rowData={grids.grid3.dataSource} // Datasource
              etcProps={{ rowSelection: "single", title: "점검방법" }}
              events={grids.grid3.events}
            />
          </SnResizeBar>
        </SnResizeBar>
      </div>
    </div>
  );
  //#endregion
});
export default SN_PRD_BAS_REG_015;
